import { render } from "./Users.vue?vue&type=template&id=443f0ca6"
const script = {}
script.render = render

export default script